import axios from "axios";
export default axios.create({


 //  baseURL: `http://localhost:5004/v1/`,//YOUR_API_URL HERE
     baseURL: `https://serverdash.notyfile.se/v1/`,//YOUR_API_URL HERE
 //   baseURL: `https://dashdemo.notyfile.se/v1/`,//YOUR_API_URL HERE








headers:   {  
    "Content-Type": "application/json"
  },
}); 
